// extracted by mini-css-extract-plugin
module.exports = {"container":"CardSwiper-module--container--3FDFY","card":"CardSwiper-module--card--1TqUx"};